import React from "react";

const LeaderboardNew = ({ data }) => {
	return (
		<>
			<h3 style={{ marginTop: "5px", marginBottom: "5px" }}>
				2026-2027 1ST PLACE LEADERBOARD
			</h3>

			<div className="left" style={{ marginBottom: "0" }}>
				<table id="birdies-top5" className="right-column-table leaderboardNew">
					<thead>
						<tr>
							<th className="center" style={{ width: "10%" }}>
								Peer Group
							</th>
							<th style={{ width: "23%" }}>Annual Operating Budget</th>
							<th>Charity Name</th>
							<th>Current Total Raised</th>
						</tr>
					</thead>
					<tbody>
						{data.peers.map((peer) => {
							return (
								<tr key={peer.group}>
									<td className="center">{peer.group}</td>
									<td>{peer.aob}</td>
									<td>{peer.charity}</td>
									<td>{peer.total}</td>
								</tr>
							);
						})}
					</tbody>
					<tfoot>
						<tr>
							<td
								colspan="4"
								style={{
									color: "#007cba",
									paddingTop: "17.5px",
									paddingLeft: "0",
									fontSize: "17px",
								}}
							>
								{`GRAND TOTAL RAISED TO DATE: ${data.total}`}
							</td>
						</tr>
					</tfoot>
				</table>
			</div>
		</>
	);
};
export default LeaderboardNew;
